// *https://www.registers.service.gov.uk/registers/country/use-the-api*

import { forwardRef, useEffect, useState } from 'react';
import { useAfiliados } from './AfiliadosProvider';
import { Select, Box, InputLabel, MenuItem, Typography } from '@mui/material';

const AfiliadoSelect = forwardRef(({ onDefaultAfiliado, onSelectAfiliado, ...props }, ref) => {
  const { afiliados } = useAfiliados();
  const [afiliadoId, setAfiliadoId] = useState('');

  useEffect(() => {
    if (onDefaultAfiliado) {
      setAfiliadoId(onDefaultAfiliado);
    }
  }, [onDefaultAfiliado]);

  useEffect(() => {
    if (afiliadoId && afiliadoId !== 0) {
      onSelectAfiliadoById(afiliadoId);
    }
  }, [afiliadoId]);

  useEffect(() => {
    if (afiliados.length === 1) {
      handleChange(afiliados[0].afiliado.idAfiliado);
    }
  }, [afiliados]);

  const handleChange = (newValue) => {
    if (newValue) {
      let afiliadoSelected = afiliados.find((a) => a.afiliado.idAfiliado === Number(newValue));
      setAfiliadoId(newValue);

      if (onSelectAfiliado) {
        onSelectAfiliado(afiliadoSelected);
      }
    }
  };

  const onSelectAfiliadoById = (idAfiliado) => {
    if (idAfiliado) {
      let afiliadoSelected = afiliados.find((a) => a.afiliado.idAfiliado === Number(idAfiliado));

      if (onSelectAfiliado) {
        onSelectAfiliado(afiliadoSelected);
      }
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <InputLabel sx={{ marginLeft: -2 }} id='afiliado-input-label'>
        Seleccioná el Afiliado
      </InputLabel>
      <Select
        id='afiliado-select'
        value={afiliadoId}
        variant='standard'
        onChange={(e) => handleChange(e.target.value)}
        defaultValue=''
        label='Seleccioná el Afiliado'
        fullWidth={true}
      >
        {afiliados.map((a) => (
          <MenuItem key={a.afiliado?.idAfiliado} value={a.afiliado?.idAfiliado}>
            <Typography variant='body2'>
              ({a.afiliado?.numeroDocumentoFormateado}) {a.personaFisica?.apellido},{' '}
              {a.personaFisica?.nombre}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
});

export default AfiliadoSelect;
